<div (click)="close()" class = "content-Display">
  <i class="fa {{data.icon}} mr-1"></i> <span *ngIf="data.title" class="title">{{data.title}}</span>
    <span *ngIf="!data.title"  class="message">{{data.message}}</span>
    <p *ngIf="data.title"  class="message">{{data.message}}</p>
</div>